import React from "react";
import MobileNavbar from "./MobileNavbar";

const BottomNavbar = () => {
  return (
    <div>
      <MobileNavbar />
    </div>
  );
};

export default BottomNavbar;